var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "formBankDetails",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.$emit("submit", _vm.values)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex eu-mb_5" },
        [
          _c(
            "b",
            [
              _c("emd-text", { attrs: { size: "medium" } }, [
                _vm._v(_vm._s(_vm.$t("title"))),
              ]),
            ],
            1
          ),
          _c(
            "emd-text",
            {
              staticClass: "eu-mt_2",
              attrs: { color: "#8B8B92", size: "medium" },
            },
            [_vm._v(" " + _vm._s(_vm.$t("description")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("div", { staticClass: "flex_group w100" }, [
            _c(
              "div",
              { staticClass: "w50" },
              [
                _c(
                  "label",
                  {
                    staticClass: "emd-label _required",
                    attrs: { for: "bank" },
                  },
                  [_vm._v(_vm._s(_vm.$t("bank")))]
                ),
                _c(
                  "emd-select",
                  {
                    staticClass: "w100",
                    attrs: { name: "bank" },
                    model: {
                      value: _vm.values.bank,
                      callback: function ($$v) {
                        _vm.$set(_vm.values, "bank", $$v)
                      },
                      expression: "values.bank",
                    },
                  },
                  [
                    _c("option", { attrs: { disabled: "", selected: "" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("bankDefaultSelect")) + " "),
                    ]),
                    _vm._l(_vm.banks, function ([code, bank]) {
                      return _c(
                        "option",
                        { key: code, domProps: { value: code } },
                        [_vm._v(" " + _vm._s(bank) + " ")]
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w50" },
              [
                _c(
                  "label",
                  {
                    staticClass: "emd-label _required",
                    attrs: { for: "type" },
                  },
                  [_vm._v(_vm._s(_vm.$t("type")) + " ")]
                ),
                _c(
                  "emd-select",
                  {
                    staticClass: "w100",
                    attrs: { name: "type" },
                    model: {
                      value: _vm.values.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.values, "type", $$v)
                      },
                      expression: "values.type",
                    },
                  },
                  [
                    _c("option", { attrs: { disabled: "", selected: "" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("typeDefaultSelect")) + " "),
                    ]),
                    _vm._l(_vm.accountTypes, function (accountType) {
                      return _c(
                        "option",
                        { key: accountType, domProps: { value: accountType } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(`recipients.create.type_${accountType}`)
                              ) +
                              " "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "flex_group w100" }, [
            _c(
              "div",
              { staticClass: "w70" },
              [
                _c(
                  "label",
                  {
                    staticClass: "emd-label _required",
                    attrs: { for: "branchNumber" },
                  },
                  [_vm._v(_vm._s(_vm.$t("branchNumber")))]
                ),
                _c("emd-input", {
                  staticClass: "w100",
                  class: {
                    _state_error:
                      _vm.$v.values.branchNumber.$invalid &&
                      _vm.$v.values.branchNumber.$dirty,
                  },
                  attrs: { name: "branchNumber", type: "number" },
                  on: { input: _vm.$v.values.branchNumber.$touch },
                  model: {
                    value: _vm.values.branchNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.values, "branchNumber", $$v)
                    },
                    expression: "values.branchNumber",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w30" },
              [
                _c(
                  "label",
                  {
                    staticClass: "emd-label",
                    attrs: { for: "branchCheckDigit" },
                  },
                  [_vm._v(_vm._s(_vm.$t("branchCheckDigit")))]
                ),
                _c("emd-input", {
                  staticClass: "w100",
                  class: {
                    _state_error:
                      _vm.$v.values.branchCheckDigit.$invalid &&
                      _vm.$v.values.branchCheckDigit.$dirty,
                  },
                  attrs: { name: "branchCheckDigit", type: "number" },
                  on: { input: _vm.$v.values.branchCheckDigit.$touch },
                  model: {
                    value: _vm.values.branchCheckDigit,
                    callback: function ($$v) {
                      _vm.$set(_vm.values, "branchCheckDigit", $$v)
                    },
                    expression: "values.branchCheckDigit",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w70" },
              [
                _c(
                  "label",
                  {
                    staticClass: "emd-label _required",
                    attrs: { for: "accountNumber" },
                  },
                  [_vm._v(_vm._s(_vm.$t("accountNumber")))]
                ),
                _c("emd-input", {
                  staticClass: "w100",
                  class: {
                    _state_error:
                      _vm.$v.values.accountNumber.$invalid &&
                      _vm.$v.values.accountNumber.$dirty,
                  },
                  attrs: { name: "accountNumber", type: "number" },
                  on: { input: _vm.$v.values.accountNumber.$touch },
                  model: {
                    value: _vm.values.accountNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.values, "accountNumber", $$v)
                    },
                    expression: "values.accountNumber",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w30" },
              [
                _c(
                  "label",
                  {
                    staticClass: "emd-label _required",
                    attrs: { for: "accountCheckDigit" },
                  },
                  [_vm._v(_vm._s(_vm.$t("accountCheckDigit")))]
                ),
                _c("emd-input", {
                  staticClass: "w100",
                  class: {
                    _state_error:
                      _vm.$v.values.accountCheckDigit.$invalid &&
                      _vm.$v.values.accountCheckDigit.$dirty,
                  },
                  attrs: { name: "accountCheckDigit", type: "number" },
                  on: { input: _vm.$v.values.accountCheckDigit.$touch },
                  model: {
                    value: _vm.values.accountCheckDigit,
                    callback: function ($$v) {
                      _vm.$set(_vm.values, "accountCheckDigit", $$v)
                    },
                    expression: "values.accountCheckDigit",
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "flex_group w100" }, [
            _c(
              "div",
              { staticClass: "w100" },
              [
                _c(
                  "label",
                  {
                    staticClass: "emd-label _required",
                    attrs: { for: "holderDocument" },
                  },
                  [_vm._v(_vm._s(_vm.$t("holderDocument")))]
                ),
                _c("emd-input", {
                  staticClass: "w100",
                  class: {
                    _state_error:
                      _vm.$v.values.holderDocument.$invalid &&
                      _vm.$v.values.holderDocument.$dirty,
                  },
                  attrs: {
                    name: "holderDocument",
                    mask: ["###.###.###-##", "##.###.###/####-##"],
                    placeholder: _vm.$t("cpfPlaceHolder"),
                  },
                  on: { input: _vm.$v.values.holderDocument.$touch },
                  model: {
                    value: _vm.values.holderDocument,
                    callback: function ($$v) {
                      _vm.$set(_vm.values, "holderDocument", $$v)
                    },
                    expression: "values.holderDocument",
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "flex_group w100" }, [
            _c(
              "div",
              { staticClass: "w100" },
              [
                _c(
                  "label",
                  {
                    staticClass: "emd-label _required",
                    attrs: { for: "holderName" },
                  },
                  [_vm._v(_vm._s(_vm.$t("holderName")))]
                ),
                _c("emd-input", {
                  class: {
                    _state_error:
                      _vm.$v.values.holderName.$invalid &&
                      _vm.$v.values.holderName.$dirty,
                  },
                  attrs: { name: "holderName" },
                  on: { input: _vm.$v.values.holderName.$touch },
                  model: {
                    value: _vm.values.holderName,
                    callback: function ($$v) {
                      _vm.$set(_vm.values, "holderName", $$v)
                    },
                    expression: "values.holderName",
                  },
                }),
                _vm.$v.values.holderName.$error &&
                _vm.$v.values.holderName.$dirty
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "emd-text _size_small _color_danger eu-mt_1",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("validations.holderName", {
                              min: _vm.$v.values.holderName?.$params?.minLength
                                .min,
                              max: _vm.$v.values.holderName?.$params?.maxLength
                                .max,
                            })
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._t("default"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }